import { HandelseFormValues } from 'components/utkast/utkastRegistration/UtkastFormSchema';

import { Handelse, HandelseTyp } from 'models';

export const sortHandelserFormValues = (
  handelser: HandelseFormValues[],
  handelsetyper?: Array<HandelseTyp>
): HandelseFormValues[] => {
  return handelser.sort((a: HandelseFormValues, b: HandelseFormValues) => {
    const a_datering_kand = a.datering_kand === 'true';
    const b_datering_kand = b.datering_kand === 'true';

    const compareNumeric = (a_from: string, a_tom: string, b_from: string, b_tom: string) => {
      const a_num = !isNaN(parseInt(a_from)) ? a_from : a_tom;
      const b_num = !isNaN(parseInt(b_from)) ? b_from : b_tom;

      return parseInt(a_num) < parseInt(b_num) ? -1 : 1;
    };

    if (a_datering_kand && b_datering_kand) {
      return compareNumeric(a.datering_from, a.datering_tom, b.datering_from, b.datering_tom);
    }

    if (!a_datering_kand && !b_datering_kand) {
      const handelsenamn_a = handelsetyper?.find((h) => h.handelsetyp == a.handelsetyp)?.namn;
      const handelsenamn_b = handelsetyper?.find((h) => h.handelsetyp == b.handelsetyp)?.namn;
      return handelsenamn_a?.localeCompare(handelsenamn_b || '') || 0;
    }

    return !a_datering_kand ? 1 : -1;
  });
};

export const sortHandelser = (handelser: Handelse[], handelsetyper?: Array<HandelseTyp>): Handelse[] => {
  return (
    handelser.sort((a: Handelse, b: Handelse) => {
      const compareNumeric = (
        a_from: number | null,
        a_tom: number | null,
        b_from: number | null,
        b_tom: number | null
      ) => {
        const a_num = a_from ? a_from : a_tom;
        const b_num = b_from ? b_from : b_tom;

        return a_num && b_num && a_num < b_num ? -1 : 1;
      };

      if (a.datering_kand && b.datering_kand) {
        return compareNumeric(a.datering_from, a.datering_tom, b.datering_from, b.datering_tom);
      }

      if (!a.datering_kand && !b.datering_kand) {
        const handelsenamn_a = handelsetyper?.find((h) => h.handelsetyp == a.handelsetyp)?.namn;
        const handelsenamn_b = handelsetyper?.find((h) => h.handelsetyp == b.handelsetyp)?.namn;
        return handelsenamn_a?.localeCompare(handelsenamn_b || '') || 0;
      }

      return !a.datering_kand ? 1 : -1;
    }) || []
  );
};
